var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary__form",on:{"click":_vm.executeClick}},[_c('div',{staticClass:"summary__form__wrapper"},[_c('label',{staticClass:"p-text xl"},[_vm._t("icon"),_c('span',[_vm._v(_vm._s(_vm.label))])],2),_c('div',{staticClass:"summary__form_wrapper__text text-bold",class:[
            'summary__form_wrapper__text',
            {
              'pre-formatted': _vm.enableNewline
            }
          ],domProps:{"innerHTML":_vm._s(_vm.input)}})]),(_vm.clickable)?_c('div',{staticClass:"pencil"},[_c('i',{staticClass:"fas fa-pencil-alt"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }